// @ts-ignore
import Swal from "sweetalert2";
// @ts-ignore
import withReactContent from "sweetalert2-react-content";
import React from "react";
import "../../assets/styles/table.css";
import { IBooking } from "../../types";
import { bookingColumns } from "../../constants/constants";
import {
  useGetBookingListQuery,
  useCancelBookingMutation,
} from "../../store/api/bookingApi";
const MySwal = withReactContent(Swal);
// Remove status column for display
const columnsToShow = bookingColumns.filter((col) => col.key !== "status");

const TableAppointment: React.FC<{
  pageNumber: number;
  setTotalCount: (count: number) => void;
  searchValue?: string;
}> = ({ pageNumber, setTotalCount, searchValue = "" }) => {
  const { data: bookingData, isLoading } = useGetBookingListQuery({
    page: pageNumber,
    search: searchValue,
  });
  const [cancelBooking, { isLoading: isCancelling }] =
    useCancelBookingMutation();

  const bookings: IBooking[] = bookingData?.data?.bookings || [];

  React.useEffect(() => {
    setTotalCount(bookingData?.data?.totalCount || 0);
  }, [bookingData, setTotalCount]);

  const handleCancel = async (id: number) => {
    const result = await MySwal.fire({
      title: "Are you sure?",
      text: "Do you really want to cancel this appointment?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it",
    });
    if (!result.isConfirmed) return;

    try {
      await cancelBooking({ bookingId: id }).unwrap();
      await MySwal.fire({
        icon: "success",
        title: "Cancelled!",
        text: "The booking has been cancelled.",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Cancel booking error:", error);
      await MySwal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to cancel the booking. Please try again.",
      });
    }
  };

  return (
    <div className="tableWrapper">
      <table className="table">
        <thead>
          <tr>
            {columnsToShow.map((col) => (
              <th key={col.key} data-column={col.key}>
                {col.label}
              </th>
            ))}
            <th>Action</th>
          </tr>
        </thead>
      </table>
      <div className="tableBodyWrapper">
        <table className="table">
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={columnsToShow.length + 1}>Loading...</td>
              </tr>
            ) : bookings.length ? (
              bookings.map((row: IBooking) => {
                const status = row.status;
                return (
                  <tr key={row.id}>
                    {columnsToShow.map((col) => (
                      <td key={col.key} data-column={col.key}>
                        {col.key === "slot_time"
                          ? row.slot_start_time && row.slot_end_time
                            ? `${row.slot_start_time}-${row.slot_end_time}`
                            : row.slot_start_time || "-"
                          : row[col.key as keyof IBooking] ?? "-"}
                      </td>
                    ))}
                    <td className="actionCell">
                      {status === "cancelled" ? (
                        <span
                          className="status-badge"
                          style={{
                            background: "#f44336",
                            color: "#fff",
                            borderRadius: 4,
                            padding: "4px 12px",
                          }}
                        >
                          Cancelled
                        </span>
                      ) : status === "approved" ? (
                        <span className="status-badge status-approved">
                          Approved
                        </span>
                      ) : (
                        <button
                          className="actionButton"
                          onClick={() => handleCancel(row.id)}
                          disabled={isCancelling}
                        >
                          Cancel
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={columnsToShow.length + 1}>No data found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableAppointment;
